import { ReactNode } from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";

interface LayoutProps {
    children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {

    return (
        <div className="min-h-screen bg-white">
            <main>{children}</main>
        </div>
    );
};

export default Layout;
